import { useMemo } from "react";

import { type User } from "@entities/user";
import { type Company } from "@entities/company";
import { useDataPage } from "@shared/lib/use-data-page";
import { useCompaniesQuery } from "@features/company/get";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";

interface UseCompaniesSourceResult {
  companies: Company[];
  isLoading: boolean;
}

export const useCompaniesSource = () => {
  const { user } = useAuthenticationContext();
  const isSuperuser = user?.isSuperuser ?? false;

  const attachedCompanies = useMemo<Company[]>(
    () => ((user as User)?.companies ?? []) as Company[],
    [user],
  );

  const { data: loadedCompaniesPage, isLoading } = useCompaniesQuery({
    enabled: !!user?.isSuperuser,
  });

  const { rows: loadedCompanies } = useDataPage(loadedCompaniesPage);

  return {
    companies: isSuperuser ? loadedCompanies : attachedCompanies,
    isLoading: isSuperuser ? isLoading : false,
  } as UseCompaniesSourceResult;
};
